import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { CModal, CModalHeader, CModalBody, CModalTitle, CSpinner } from '@coreui/react';
import MarketplaceService from '../services/MarketplaceService';
import '../scss/main.scss';

const ListingHistoryModal = ({ show, onHide, listingId, nftDetails }) => {
      const [history, setHistory] = useState([]);
      const [loading, setLoading] = useState(true);
      const [error, setError] = useState(null);
      const marketplaceService = new MarketplaceService();

      useEffect(() => {
            const fetchHistory = async () => {
                  if (!show || !listingId) return;

                  setLoading(true);
                  setError(null);
                  try {
                        const response = await marketplaceService.getListingHistory(listingId);
                        console.log('History response:', response);
                        setHistory(response.history || []);
                  } catch (err) {
                        console.error('Failed to fetch history:', err);
                        setError(err.message || 'Failed to load history');
                  } finally {
                        setLoading(false);
                  }
            };

            fetchHistory();
      }, [show, listingId]);

      const formatDate = (dateString) => {
            return new Date(dateString).toLocaleString();
      };

      const formatPrice = (price) => {
            return typeof price === 'number' ? price.toFixed(2) : price;
      };

      const getEventLabel = (event) => {
            switch (event?.toLowerCase()) {
                  case 'list': return 'Listed';
                  case 'buy': return 'Purchased';
                  case 'cancel': return 'Cancelled';
                  case 'update': return 'Price Updated';
                  default: return event;
            }
      };

      return (
            <CModal visible={show} onClose={onHide} className="listing-history-modal">
                  <CModalHeader closeButton>
                        <CModalTitle>Transaction History</CModalTitle>
                  </CModalHeader>
                  <CModalBody>
                        {loading ? (
                              <div className="text-center py-4">
                                    <CSpinner />
                              </div>
                        ) : error ? (
                              <div className="alert alert-danger">{error}</div>
                        ) : history.length === 0 ? (
                              <div className="text-center mb-2 py-4">
                                    No transaction history available
                              </div>
                        ) : (
                              <div className="history-timeline">
                                    {history.map((event, index) => (
                                          <div key={index} className="history-item">
                                                <div className="history-marker"></div>
                                                <div className="history-content">
                                                      <div className="event-type">
                                                            {getEventLabel(event.event)}
                                                      </div>
                                                      <div className="event-details">
                                                            {event.price && (
                                                                  <div className="price">
                                                                        Price: {formatPrice(event.price)} MiEROS
                                                                  </div>
                                                            )}
                                                            {event.from && (
                                                                  <div className="from">
                                                                        From: {event.from}
                                                                  </div>
                                                            )}
                                                            {event.to && (
                                                                  <div className="to">
                                                                        To: {event.to}
                                                                  </div>
                                                            )}
                                                            <div className="timestamp">
                                                                  {formatDate(event.timestamp || event.date)}
                                                            </div>
                                                      </div>
                                                </div>
                                          </div>
                                    ))}
                              </div>
                        )}
                  </CModalBody>
            </CModal>
      );
};

ListingHistoryModal.propTypes = {
      show: PropTypes.bool.isRequired,
      onHide: PropTypes.func.isRequired,
      listingId: PropTypes.string,
      nftDetails: PropTypes.object
};

export default ListingHistoryModal; 

